import { useSelector } from 'src/store';
import { selectors } from 'src/store/navbar';

export const useInlineFilterButtonsDockedStates = () =>
  useSelector((state) => ({
    isDockedOnDesktop: selectors.selectInlineFilterButtonsDockedDesktop(state),
    isDockedOnTablet: selectors.selectInlineFilterButtonsDockedTablet(state),
    isDockedOnMobile: selectors.selectInlineFilterButtonsDockedMobile(state),
    isShowing: selectors.selectInlineFilterButtons(state),
  }));
